class StoreLocator {
  static searchForm;
  static locationInput;
  static distanceSelect;
  static resultsLimitSelect;
  static formSubmit;
  static filtersContainer;
  static directionsBackButton;

  static init() {
    StoreLocator.searchForm = document.querySelector('.show-addresses .search_bar');
    StoreLocator.locationInput = document.getElementById('address_search');
    StoreLocator.distanceSelect = document.getElementById('within_distance');
    StoreLocator.resultsLimitSelect = document.getElementById('limit');
    StoreLocator.formSubmit = document.getElementById('submitBtn');
    StoreLocator.filtersContainer = document.getElementById('search_filters');
    StoreLocator.addressContainers = document.querySelectorAll('.show-addresses .addresses');
    StoreLocator.directionsBackButton = document.querySelector('#directions_text .return_to_results');

    StoreLocator.initForm();
  }

  static initForm() {
    if (!SCMap) {
      setTimeout(StoreLocator.initForm, 100);
      return;
    }

    StoreLocator.addListeners();
    StoreLocator.updateFormMarkup();
    StoreLocator.updateFilterOptions();
    StoreLocator.search();
  }

  static addListeners() {
    StoreLocator.locationInput.addEventListener('change', StoreLocator.updateFilterOptions);
  }

  static updateFormMarkup() {
    StoreLocator.wrapFields();
    StoreLocator.updateFormLabels();
    StoreLocator.updateFormSubmit();
    StoreLocator.addFiltersLabel();
    StoreLocator.wrapAddresses();
    StoreLocator.updateDirections();
  }

  static wrapFields() {
    const formFieldsWrapper = document.createElement('div');
    formFieldsWrapper.classList.add('search_bar_inner');

    const wrapField = child => formFieldsWrapper.appendChild(child);
    Array.from(StoreLocator.searchForm.children).forEach(wrapField);

    StoreLocator.searchForm.appendChild(formFieldsWrapper);
  }

  static updateFormLabels() {
    const label = document.createElement('label');
    label.setAttribute('for', StoreLocator.locationInput.id);
    label.textContent = StoreLocator.locationInput.getAttribute('placeholder').replace('/', ' / ');
    StoreLocator.locationInput.after(label);
  }

  static updateFormSubmit() {
    StoreLocator.locationInput.parentElement.appendChild(StoreLocator.formSubmit);
    StoreLocator.formSubmit.innerHTML = `
      <span>
        <span class="visually-hidden">${StoreLocator.formSubmit.textContent}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
          class="icon icon-search"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path fill="currentColor" fill-rule="evenodd" d="M15.7 14.7h-.85l-.3-.29a6.984 6.984 0 0 0 1.7-4.57c0-3.88-3.15-7.03-7.03-7.03S2.19 5.96 2.19 9.84s3.15 7.03 7.03 7.03c1.74 0 3.34-.64 4.57-1.7l.29.3v.85l5.41 5.39 1.61-1.61-5.39-5.41Zm-6.49 0c-2.69 0-4.86-2.17-4.86-4.86s2.17-4.86 4.86-4.86 4.86 2.17 4.86 4.86-2.17 4.86-4.86 4.86Z"/>
        </svg>
      </span>
    `;
    StoreLocator.formSubmit.classList.add('icon-link');
  }

  static addFiltersLabel() {
    const filtersLabel = document.createElement('h3');
    filtersLabel.classList.add('search_filters_label', 'h5');
    filtersLabel.textContent = window.filterStrings.filterBy;
    StoreLocator.filtersContainer.prepend(filtersLabel);
  }

  static wrapAddresses() {
    const parentElement = StoreLocator.addressContainers[0].parentElement;
    const addressesWrapper = document.createElement('div');
    addressesWrapper.classList.add('addresses_wrapper');

    const wrapAddress = child => addressesWrapper.appendChild(child);
    StoreLocator.addressContainers.forEach(wrapAddress);

    parentElement.appendChild(addressesWrapper);
  }

  static updateDirections() {
    StoreLocator.directionsBackButton.innerHTML = StoreLocator.directionsBackButton.innerHTML.replace('&lt;&lt; ', `
      <svg
        viewBox="0 0 14 10"
        fill="none"
        aria-hidden="true"
        focusable="false"
        class="icon icon-arrow"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor" />
      </svg>
    `);
  }

  static updateFilterOptions() {
    StoreLocator.resultsLimitSelect.value = '100';
    StoreLocator.distanceSelect.value = StoreLocator.locationInput.value === '' ? '0' : '100';
  }
  
  static search() {
    if (typeof codeAddress === 'function') {
      codeAddress();
    } else {
      StoreLocator.formSubmit.click();
    }
  }
}

document.addEventListener('DOMContentLoaded', StoreLocator.init);